import React, { useState } from 'react';
import clsx from 'clsx';
import { Hero } from '../../components/Hero';
import { ApplySection } from '../../components/ApplySection';
import AibleLogo from '../../assets/images/sponsors/aible.png';
import DataIkuLogo from '../../assets/images/sponsors/data-iku.png';
import DotDataLogo from '../../assets/images/sponsors/dotData.png';
import TecholutionLogo from '../../assets/images/sponsors/techolution.png';

import './sponsors.css';

const categories = [
  {
    id: '',
    label: 'All Categories',
  },
  {
    id: 'diamond',
    label: 'Diamond Level',
  },
  {
    id: 'platinum',
    label: 'Platinum Level',
  },
  {
    id: 'gold',
    label: 'Gold Level',
  },
  {
    id: 'silver',
    label: 'Silver Level',
  },
  {
    id: 'startup',
    label: 'Startup Level',
  },
  {
    id: 'exhibitor',
    label: 'Exhibitor',
  },
  {
    id: 'media-partner',
    label: 'Media Partner',
  },
];

const logos = [
  {
    id: 0,
    logo: TecholutionLogo,
    categories: [
      'diamond',
    ]
  },
  {
    id: 1,
    logo: DataIkuLogo,
    categories: [
      'diamond',
    ]
  },
  {
    id: 2,
    logo: DotDataLogo,
    categories: [
      'diamond',
    ]
  },
  {
    id: 3,
    logo: AibleLogo,
    categories: [
      'diamond',
    ]
  },
];

function SponsorsPage() {
  const [selectedCategory, setSelectedCategory] = useState({
    id: '',
    label: 'All Categories',
  });

  const filtered = selectedCategory.id ? logos.filter(item => item.categories.indexOf(selectedCategory.id) > -1) : logos;

  return (
    <div className="sponsors-page">
      <div className="sponsors-hero-wrapper">
        <Hero
          title="Sponsors & Exhibitors"
          description="Make connections with people who can help push your AI initiatives forward. Our attendees are the reason Ai4 2023 is the industry’s most impactful AI event."
          buttonLabel="BECOME A SPONSOR"
        />
      </div>
    
      <div className="attending-companies">
        <h1 className="title">2024 Sponsors</h1>
        <div className="row flex-wrap gap-10 justify-content-center">
          {
            categories.map(category => (
              <button
                key={category.id}
                className={clsx('category', category.id === selectedCategory.id && 'selected-category')}
                onClick={() => setSelectedCategory(category)}
              >
                {category.label}
              </button>
            ))
          }
        </div>
        <div className="row flex-wrap gap-18 justify-content-center companies">
          {
            filtered.map(company => (
              <div
                key={company.id}
                className="company"
              >
                <img src={company.logo} alt="Company" />
              </div>
            ))
          }
        </div>
      </div>
      <ApplySection
        title="Explore Sponsorship Opportunities"
        description="Connect with Us Now to Secure Your Spot! Limited Spaces Available on a First-Come, First-Served Basis!"
        buttonLabel="APPLY NOW"
      />
    </div>
  );
}

export default SponsorsPage;
